var r = function (e) {
    return e.default = "default", e.defaultTop = "defaultTop", e.right = "right", e.rightTop = "rightTop", e.center = "center", e.centerTop = "centerTop", e;
  }(r || {}),
  t = function (e) {
    return e.default = "default", e.large = "large", e;
  }(t || {});
export { r as CalendarPosition, t as InputPickerSize };